// src/components/YearRange.js
import React, { useEffect, useMemo, useRef, useState } from 'react';
import Dropdown from './Dropdown';

export default function YearRange({ years, min, max, onChange }) {
  const [open, setOpen] = useState(false);
  const rootRef = useRef(null);
  useEffect(()=>{
    const onDoc = e => { if (!rootRef.current?.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', onDoc);
    return ()=> document.removeEventListener('mousedown', onDoc);
  },[]);
  const opts = useMemo(()=> years.map(y=>({ value:y, label:String(y) })), [years]);

  return (
    <div ref={rootRef} className={`yr ${open ? 'open' : ''}`}>
      <button className="dd-head yr-head" type="button" onClick={()=>setOpen(o=>!o)}>
        <span>{min || 'Any'} – {max || 'Any'}</span>
        <span className="dd-caret" />
      </button>
      {open && (
        <div className="yr-panel">
          <div className="yr-row">
            <label>Start</label>
            <Dropdown value={min ?? ''} onChange={v=>onChange('yearMin', v || '')} options={opts} placeholder="Any" />
          </div>
          <div className="yr-row">
            <label>End</label>
            <Dropdown value={max ?? ''} onChange={v=>onChange('yearMax', v || '')} options={opts} placeholder="Any" />
          </div>
        </div>
      )}
    </div>
  );
}